import React from 'react';

/**
 * Skeleton that mirrors the public Show detail layout: full-width backdrop +
 * poster + title strip, then a row of meta chips and the seasons grid.
 * Used in place of the spinner on /show/:tmdb_id while data is fetching.
 */
const PublicShowSkeleton = () => (
  <div className="ps-skel" data-testid="show-loading">
    <div className="ps-skel-backdrop shimmer" />
    <div className="ps-skel-hero">
      <div className="ps-skel-poster shimmer" />
      <div className="ps-skel-text">
        <div className="ps-skel-line shimmer" style={{ width: '40%', height: 18 }} />
        <div className="ps-skel-line shimmer" style={{ width: '78%', height: 32, marginTop: 12 }} />
        <div className="ps-skel-chips">
          <div className="ps-skel-chip shimmer" />
          <div className="ps-skel-chip shimmer" />
          <div className="ps-skel-chip shimmer" />
        </div>
        <div className="ps-skel-line shimmer" style={{ width: '95%', height: 12, marginTop: 24 }} />
        <div className="ps-skel-line shimmer" style={{ width: '90%', height: 12, marginTop: 8 }} />
        <div className="ps-skel-line shimmer" style={{ width: '60%', height: 12, marginTop: 8 }} />
      </div>
    </div>

    <div className="ps-skel-section">
      <div className="ps-skel-line shimmer" style={{ width: 220, height: 22 }} />
      <div className="ps-skel-row">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="ps-skel-season shimmer" />
        ))}
      </div>
    </div>

    <style jsx>{`
      .ps-skel {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 1.5rem 3rem;
      }
      .ps-skel-backdrop {
        height: 280px;
        margin: 0 -1.5rem 1.5rem;
        border-bottom-left-radius: 18px;
        border-bottom-right-radius: 18px;
      }
      .ps-skel-hero {
        display: grid;
        grid-template-columns: 1fr;
        gap: 1.5rem;
        margin-bottom: 3rem;
      }
      @media (min-width: 720px) {
        .ps-skel-hero {
          grid-template-columns: 220px 1fr;
        }
      }
      .ps-skel-poster {
        aspect-ratio: 2 / 3;
        border-radius: 12px;
        max-width: 220px;
      }
      .ps-skel-text { display: flex; flex-direction: column; }
      .ps-skel-line { border-radius: 6px; }
      .ps-skel-chips { display: flex; gap: 0.6rem; margin-top: 1rem; flex-wrap: wrap; }
      .ps-skel-chip {
        width: 100px;
        height: 28px;
        border-radius: 999px;
      }
      .ps-skel-section { margin-top: 2.5rem; }
      .ps-skel-row {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 1rem;
        margin-top: 1rem;
      }
      @media (min-width: 720px) {
        .ps-skel-row { grid-template-columns: repeat(4, 1fr); }
      }
      .ps-skel-season {
        aspect-ratio: 2 / 3;
        border-radius: 10px;
      }
      .shimmer {
        position: relative;
        overflow: hidden;
        background: linear-gradient(135deg, #161616 0%, #0e0e0e 100%);
      }
      .shimmer::after {
        content: '';
        position: absolute;
        inset: 0;
        background: linear-gradient(
          90deg,
          transparent 0%,
          rgba(230, 47, 136, 0.07) 40%,
          rgba(230, 47, 136, 0.14) 50%,
          rgba(230, 47, 136, 0.07) 60%,
          transparent 100%
        );
        transform: translateX(-100%);
        animation: psshimmer 1.4s ease-in-out infinite;
      }
      @keyframes psshimmer {
        100% { transform: translateX(100%); }
      }
    `}</style>
  </div>
);

export default PublicShowSkeleton;
